import Amplify, {Auth} from 'aws-amplify';
import {getLogger, Logger} from './LoggingService';

interface ICognitoConfig {
  userPoolId: string;
  clientId: string;
  identityPoolId: string;
  domain: string;
  hostedAuthenticationUrl: string;
  logoutUrl: string;
}

interface RTColumn {
  field: string;
  headerName: string;
  hide?: boolean;
  width?: number
}

type RTMetricsTableConfiguration = RTColumn[]

interface RTMetricsTablesConfigurations {
  realTimeQueueMetrics: RTMetricsTableConfiguration;
  realTimeRoutingProfileMetrics: RTMetricsTableConfiguration;
  realTimeAgentMetrics: RTMetricsTableConfiguration;
  realTimeMetricsSnapshot: RTMetricsTableConfiguration;
}
export default class ConfigurationService {
  private logger: Logger;
  loaded = false;

  // These properties are assigned from config.json
  environment: string = '';
  region: string = '';
  apiUrl: string = '';
  cognito: ICognitoConfig = {
    userPoolId: '',
    clientId: '',
    identityPoolId: '',
    domain: '',
    hostedAuthenticationUrl: '',
    logoutUrl: ''
  };
  version: string = '';
  metricsTableConfigurations: RTMetricsTablesConfigurations = {
    realTimeQueueMetrics: null,
    realTimeRoutingProfileMetrics: null,
    realTimeAgentMetrics: null,
    realTimeMetricsSnapshot: null
  }


  constructor() {
    this.logger = getLogger('ConfigurationService');
  }


  private async fetchCustomTableConfigs () {
    try {
      return await fetch('/customMetricsTableConfigs.json').then(res => res.json());
    }
    catch(err) {
      console.log(err);
      return null;
    }
  }
  
  public async load() {
    // Fetch environment configuration
    const response = await fetch('/config.json');
    const cfg = await response.json();
    // Fetch custom column configuration for metrics
    const customTableConfigs = await this.fetchCustomTableConfigs();
    // merge configs
    Object.assign(this, cfg, {
      metricsTableConfigurations: customTableConfigs ? customTableConfigs : this.metricsTableConfigurations
    });
    this.logger.debug('Config Loaded');
    // cofnigure amplify library
    this.configureAmplify();
    this.loaded = true;
  }

  get loginUrl(): string {
    return window.location.origin;
  }

  isLocal(): boolean {
    return this.environment === 'local';
  }
  isDev(): boolean {
    return this.environment === 'dev';
  }

  private configureAmplify(): void {
    Amplify.Logger.LOG_LEVEL =
      this.isLocal() || this.isDev() ? 'DEBUG' : 'INFO';
    const options = {
      Analytics: {
        disabled: true,
      },
      Auth: {
        region: this.region,
        userPoolId: this.cognito.userPoolId,
        userPoolWebClientId: this.cognito.clientId,
        //identityPoolId: this.cognito.identityPoolId,
        oauth: {
          domain: this.cognito.domain,
          scope: ['email', 'openid', 'profile'],
          redirectSignIn: this.loginUrl,
          redirectSignOut: this.cognito.logoutUrl ? this.cognito.logoutUrl : this.loginUrl + '/logout/',
          responseType: 'code',
          mandatorySignIn: true,
        },
      },
    };
    Auth.configure(options);
  }
}
